// test2571
(2571 && 0);
